import { createSelector } from '@ngrx/store';
import { OrderType } from 'graphql-api/gql-api-interfaces';

import { DeliveryPeriodType } from '../../models';
import {
  selectCurrentlyActiveDeliveryShopKey,
  selectNowDeliveryPeriods,
} from '../business/config-strip-business.selectors';
import {
  selectAvailableInventories,
  selectCurrentShopCurrentDeliveryPeriodType,
} from '../config-strip.selectors';

export const selectAvailableNowInventories = createSelector(
  selectAvailableInventories(true),
  (inventories) =>
    inventories.filter((inventory) => inventory.orderType === OrderType.Now),
);

export const selectHasNowInventories = createSelector(
  selectAvailableNowInventories,
  (inventories) => inventories.length > 0,
);

export const availableInventoryCount = createSelector(
  selectAvailableInventories(true),
  (inventories) => inventories.length,
);
export const hasOnlyNowInventory = createSelector(
  selectAvailableNowInventories,
  availableInventoryCount,
  (nowInventory, allInventoryCount) =>
    nowInventory.length === allInventoryCount,
);

export const selectIsNowSelected = createSelector(
  selectCurrentShopCurrentDeliveryPeriodType,
  (currentDeliveryPeriodType) =>
    currentDeliveryPeriodType === DeliveryPeriodType.Now,
);

export const selectCurrentShopNowDeliveryPeriods = createSelector(
  selectNowDeliveryPeriods,
  selectCurrentlyActiveDeliveryShopKey,
  (deliveryPeriods, shopId) =>
    deliveryPeriods ? deliveryPeriods[shopId][DeliveryPeriodType.Now] : {},
);

export const selectCurrentShopNowDeliveryPeriod = createSelector(
  selectCurrentShopNowDeliveryPeriods,
  (nowDeliveryPeriods) =>
    [...(nowDeliveryPeriods?.deliveryPeriods ?? [])].sort(
      (a, b) => new Date(a).getTime() - new Date(b).getTime(),
    )[0],
);
